"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeSchema = void 0;
const zod_1 = require("zod");
// Define a generic schema for the `Change<T>` interface
const changeSchema = (type) => zod_1.z.object({
    previousValue: zod_1.z.nullable(type),
    currentValue: zod_1.z.nullable(type),
});
exports.changeSchema = changeSchema;
//# sourceMappingURL=change.schema.js.map